<template>
  <BCard no-body>
    <BCardHeader class="align-items-baseline">
      <div class="w-100">
        <BCardTitle>
          <slot name="title"></slot>
        </BCardTitle>
      </div>
    </BCardHeader>
    <BCardBody>
      <VueApexCharts
        v-if="isRenderingChart"
        type="line"
        height="400"
        :options="chartOptions"
        :series="chartOptions.series"
      />
    </BCardBody>
  </BCard>
</template>
<script>
export default {
  props: {
    getChartData: {
      type: Function,
      required: true,
    },
    yTitle: {
      type: String,
      default: " تعداد جلسات: ",
    },
  },
  mounted() {
    const _this = this;
    this.getChartData(_this);
  },
  data() {
    return {
      chartOptions: {
        stroke: {
          curve: "smooth",
        },
        chart: {
          fontFamily: "IranSans",
        },
        series: [],
        colors: [
          "#a50000",
          "#005f96",
          "#00a53f",
          "#000000",
          "#5c0064",
          "#fa1db8ee",
        ],
        dataLabels: {
          position: "top",
          enabled: true,
          style: {
            fontFamily: "IranSans",
            fontWeight: "normal",
          },
        },
        tooltip: {
          style: {
            fontWeight: "normal",
          },
          y: {
            title: {
              formatter: (seriesName, index) => this.yTitle,
            },
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "روز های هفته",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          fontFamily: "IranSans",
          fontWeight: "normal",
          labels: {
            colors: ["#000000"],
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#fff",
            fillColors: undefined,
            radius: 12,
            offsetX: "5px",
          },
        },
      },
      chartPayload: {
        pageNumber: 1,
        count: 50,
      },
      isRenderingChart: false,
    };
  },
  methods: {
    async sendChartRequest(resetChart = true) {
      if (resetChart) {
        this.isRenderingChart = false;
      }
      let _this = this;
      await this.getChartData(_this);
      this.isRenderingChart = true;
    },
  },
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
};
import { BCard, BCardHeader, BCardTitle, BCardBody } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
</script>
